'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('InstanceSettings', ['$rootScope', 'IORestangular', function ($rootScope, IORestangular) {
    let _taskAssignmentsDefaultFilterValue = null

    return {
        isModuleAvailable(name) {
            return $rootScope.util.isModuleAvailable(name);
        },

        getSettingType(name) {
            return IORestangular.one('/instanceSettings').get({instanceSettingType: name});
        },

        addSettingType(name, value) {
            return IORestangular
                .all('/instanceSettings/activities')
                .post({instanceSettingType: name, value: value})
                .then((data) => {
                    this._setTaskAssignmentsDefaultFilterValue(data)
                })
        },

        _setTaskAssignmentsDefaultFilterValue(data, callback) {
            if (!(data.value && typeof data.value === 'string')) {
                if (callback) {
                    callback()
                }
                return
            }

            _taskAssignmentsDefaultFilterValue = data.value
        },

        updateSettingType(name, value) {
            return IORestangular
                .one('/instanceSettings/activities')
                .put({instanceSettingType: name, value: value})
                .then((data) => {
                    this._setTaskAssignmentsDefaultFilterValue(data)
                })
        },

        deleteSettingType(name) {
            return IORestangular
                .all('/instanceSettings/activities')
                .remove({instanceSettingType: name})
                .then(() => {
                    _taskAssignmentsDefaultFilterValue = null
                })
        },

        FILTER_TASK_ASSIGNMENTS: 'filter-task-assignments',
        getTasksAssignmentsDefaultFilterValue(withDefaultFilterCallback, withNoDefaultFilterCallback = false) {
            if (_taskAssignmentsDefaultFilterValue) {
                withDefaultFilterCallback(_taskAssignmentsDefaultFilterValue)
                return
            }

            this.getSettingType(this.FILTER_TASK_ASSIGNMENTS).then((data) => {
                if (!(data.value && typeof data.value === 'string')) {
                    if (withNoDefaultFilterCallback) {
                        withNoDefaultFilterCallback()
                    }
                    return
                }

                _taskAssignmentsDefaultFilterValue = data.value
                withDefaultFilterCallback(_taskAssignmentsDefaultFilterValue)
            })
        },

        FUSION_SEVEN_PAYMENT_URL: 'fusion-seven-payment-url',
        FUSION_SEVEN_PAYMENT_METHODS_URL: 'fusion-seven-payment-methods-url',
        FUSION_SEVEN_API_KEY: 'fusion-seven-api-key',
        FUSION_SEVEN_ORG_ID: 'fusion-seven-organization_id',
        EXPORT_BUYSHEET_TO_EXCEL: 'export_buysheet_to_excel'
    }
}])